(function () {
  const csPdpCartSelectors = {
    submit: '[data-cs-pdp-cart-submit]',
    error: '.cs-pdp-cart-error'
  }

  const loadingClass = 'is-loading'

  let requestInFlight = false

  function getRoute() {
    return (window.theme && window.theme.routes && window.theme.routes.cartAdd) || '/cart/add.js'
  }

  function clearError(form) {
    const existing = form.querySelector(csPdpCartSelectors.error)
    if (existing) existing.remove()
  }

  function showError(form, message) {
    clearError(form)
    const error = document.createElement('p')
    error.className = 'cs-pdp-cart-error'
    error.setAttribute('role', 'alert')
    error.textContent = message
    form.append(error)
  }

  function setLoading(button, isLoading) {
    button.classList.toggle(loadingClass, isLoading)
    button.setAttribute('aria-busy', isLoading ? 'true' : 'false')
    button.disabled = isLoading
  }

  function getPurchaseMultiplier(form) {
    const checkedOption = form.querySelector('[data-purchase-multiplier]:checked')
    const select = form.querySelector('select[data-purchase-multiplier-select]')
    const source = checkedOption || (select && select.options[select.selectedIndex])
    if (!source) return 1

    const multiplier = parseInt(source.dataset.purchaseMultiplier, 10)
    return Number.isNaN(multiplier) || multiplier < 1 ? 1 : multiplier
  }

  function onSubmit(event) {
    const button = event.currentTarget.querySelector(csPdpCartSelectors.submit)
    if (!button) return

    event.preventDefault()
    if (requestInFlight) return

    const form = event.currentTarget
    clearError(form)

    const body = new FormData(form)
    const requestedQuantity = parseInt(body.get('quantity'), 10) || 1
    body.set('quantity', requestedQuantity * getPurchaseMultiplier(form))

    requestInFlight = true
    setLoading(button, true)

    fetch(getRoute(), {
      method: 'POST',
      body: body,
      headers: { 'X-Requested-With': 'XMLHttpRequest' }
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.status) {
          showError(form, data.description || data.message)
          return
        }

        document.documentElement.dispatchEvent(
          new CustomEvent('cart:refresh', {
            detail: { product: data, addToCartBtn: button },
            bubbles: true
          })
        )
      })
      .catch((error) => {
        console.warn(error)
      })
      .finally(() => {
        requestInFlight = false
        setLoading(button, false)
      })
  }

  function bind() {
    document.querySelectorAll(csPdpCartSelectors.submit).forEach((button) => {
      const form = button.closest('form')
      if (!form || form.dataset.csPdpCartBound === 'true') return

      form.dataset.csPdpCartBound = 'true'
      form.addEventListener('submit', onSubmit)
    })
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bind)
  } else {
    bind()
  }

  document.addEventListener('shopify:section:load', bind)
})()
